import type { JSX } from 'react';

import { ColumnConfig, ColumnType } from 'Components/Table/Columns';
import { Table } from 'Components/Table/Table';
import { getFrameworkGroupControlURL } from 'Helpers/URLBuilder/URLBuilder';
import { AlertResponse } from 'Models/Alerts';

export interface AlertsTableProps {
    alertsResponseList: AlertResponse[];
}

export const AlertsTable = (props: AlertsTableProps): JSX.Element => {
    const columns: ColumnConfig<AlertResponse>[] = [
        {
            type: ColumnType.STRING,
            name: 'Title',
            getString: (alert) => alert.title,
            getOnClickTextAction: (alert) => ({
                goToLocation: getFrameworkGroupControlURL(alert.entity_id),
            }),
        },
        {
            type: ColumnType.DATE,
            name: 'Date',
            getDateString: (alert) => alert.created_time,
        },
        {
            type: ColumnType.STRING,
            name: 'Alert Limit',
            getString: (alert) => alert.alert_limit,
        },
        {
            type: ColumnType.STRING,
            name: 'Current Level',
            getString: (alert) => alert.value,
        },
    ];

    return <Table<AlertResponse> columns={columns} defaultSortColumn="Date" defaultSortDirection="descending" filters={[]} getUniqueIdForRow={(alert) => `${alert.entity_id}-${alert.created_time}`} rowsData={props.alertsResponseList} />;
};
